module.exports = __webpack_public_path__ + "static/media/instructions_1.74cc9c8d.svg";